import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext({ user: undefined, setUser: () => {}, refreshAuth: async () => {} });

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = checking, null = logged out

    const refreshAuth = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            try {
                await api.post("/auth/refresh");
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                setUser(null);
            }
        }
    }, []);

    useEffect(() => {
        refreshAuth();
    }, [refreshAuth]);

    return <AuthContext.Provider value={{ user, setUser, refreshAuth }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
